export { default } from './IconCard';
